import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GTPALState {
  gravida: number | undefined;
  term: number | undefined;
  preterm: number | undefined;
  abortion: number | undefined;
  living: number | undefined;
}

const initialState: GTPALState = {
  gravida: undefined,
  term: undefined,
  preterm: undefined,
  abortion: undefined,
  living: undefined,
};

const reducers = {
  setGTPALValues: (state: GTPALState, action: PayloadAction<Partial<GTPALState>>) => {
    return { ...state, ...action.payload };
  },
};

export const gtpalSlice = createSlice({
  name: "gtpal",
  initialState,
  reducers,
});

export const { setGTPALValues } = gtpalSlice.actions;

export default gtpalSlice.reducer;
